//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.models

import com.tixforgigs.apax.models.Address
import com.tixforgigs.apax.models.Generic

        import kotlinx.serialization.*
  import kotlinx.serialization.descriptors.*
  import kotlinx.serialization.encoding.*

/**
* The organizer model
* 
* @param id The organizer id
* @param name The organizer name
* @param additionalNames The list of additional names of co-organizers
* @param address 
* @param website The website url of the organizer
*/
@Serializable

data class Organizer (


      /* The organizer id */
    @SerialName(value = "id") @Required val id: kotlin.uuid.Uuid,


      /* The organizer name */
    @SerialName(value = "name") @Required val name: kotlin.String,


      /* The list of additional names of co-organizers */
    @SerialName(value = "additionalNames") val additionalNames: kotlin.collections.List<Generic>? = null,


      @SerialName(value = "address") val address: Address? = null,


      /* The website url of the organizer */
    @SerialName(value = "website") val website: kotlin.String? = null


) {




  }

